export default __webpack_public_path__ + "static/media/about-hero.bee7451e.jpg";